import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchBox, WithSearch } from "@elastic/react-search-ui";
import { Fragment, useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import { ReactComponent as SearchIcon } from "../../assets/icons/magnifying-glass.svg";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import { normalizeSearchTerm } from "../../utils/functions";
import { SearchFieldAutocomplete } from "../search-field/SearchField";
import "../search-field/searchfield.css";
const ResultPageSearchFieldInput = ({ getAutocomplete, getInputProps, getButtonProps, }) => {
    const [disabled, setDisabled] = useState(false);
    function customOnInput(e) {
        setDisabled(e.currentTarget.value === "");
        return e.currentTarget.value;
    }
    return (_jsxs(Fragment, { children: [_jsx("input", { ...getInputProps(), placeholder: useIntl().formatMessage({ id: "searchPlaceholder" }), "aria-label": "Search input field", "data-testid": "customSearchField", onInput: customOnInput }), getAutocomplete(), _jsx("button", { ...getButtonProps({
                    disabled: disabled,
                }), "data-testid": "searchButton", "aria-label": "Search button", children: _jsx(SearchIcon, {}) })] }));
};
export const SidebarSearchField = ({ filters }) => {
    const uiStore = useContext(UIStateStoreContext);
    useEffect(() => {
        if (filters) {
            uiStore.setAutocompleteFilters(filters);
        }
    }, [filters]);
    return (_jsx(WithSearch, { mapContextToProps: ({ setSearchTerm }) => ({ setSearchTerm }), children: ({ setSearchTerm }) => (_jsx(SearchBox, { onSubmit: (searchTerm) => {
                if (searchTerm) {
                    setSearchTerm(normalizeSearchTerm(searchTerm), { shouldClearFilters: false });
                }
            }, autocompleteMinimumCharacters: 3, autocompleteResults: {
                linkTarget: "_blank",
                titleField: "title",
                urlField: "url",
                shouldTrackClickThrough: true,
                clickThroughTags: ["autocomplete"],
            }, autocompleteSuggestions: true, searchAsYouType: false, shouldClearFilters: false, autocompleteView: SearchFieldAutocomplete, inputView: ResultPageSearchFieldInput })) }));
};
